import HistoryWorker from '@/workers/History?worker'
import * as Comlink from 'comlink'
import { createContext } from 'react'
export const WorkerContext = createContext({})

const WorkerProvider = ({ children }) => {
  const historyWorker = Comlink.wrap(new HistoryWorker())

  return (
    <WorkerContext.Provider
      value={{
        historyWorker,
      }}
    >
      {children}
    </WorkerContext.Provider>
  )
}

export default WorkerProvider
